import React, { useEffect, useState } from "react";
import { Button, DocumentViewerATS, FormFieldSet, LogoLoader, Modal, showToast } from "../../../../../components";
import { updateAgreementLeadCompany } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";

const OldInformation = ({ oldInfo, companyUiid, onUpdated }) => {
    // console.log("old", oldInfo)
    const [files, setFiles] = useState([]);
    const [filesChanged, setFilesChanged] = useState(false);
    const [existingFiles, setExistingFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        jobTitle: "",
        country: "",
        location: "",
        startDate: "",
        expiryDate: "",
        agreementType: "",
    });
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [viewModal, setViewModal] = useState(false);
    const [awsUrl, setAwsUrl] = useState("");
    const [awsHtml, setAwsHtml] = useState("");
    const [awsLoading, setAwsLoading] = useState(false);

    const handleChange = (key, value) => {
        setForm(prev => ({ ...prev, [key]: value }));
    };

    const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx"];
    const handleFileChange = (input) => {
        if (Array.isArray(input)) {
            setFiles(input);
            setFilesChanged(true);
            return;
        }
        if (input?.target?.files) {
            setFiles(Array.from(input.target.files));
            setFilesChanged(true);
        }
    };

    const handleSave = async () => {
        if (filesChanged && files.length > 0) {
            const invalidFiles = files.filter(file => {
                const ext = file.name.split(".").pop().toLowerCase();
                return !ALLOWED_EXTENSIONS.includes(ext);
            });

            if (invalidFiles.length > 0) {
                showToast(
                    "Only PDF, DOC and DOCX files are allowed",
                    "error"
                );
                return;
            }
        }
        try {
            setLoading(true);
            const formData = new FormData();
            let city = null;
            let state = null;

            if (form.location) {
                const locationValue =
                    typeof form.location === "string"
                        ? form.location
                        : form.location.value || form.location.label || "";

                if (locationValue.includes("-")) {
                    const [c, s] = locationValue.split("-").map(v => v.trim());
                    city = c || null;
                    state = s || null;
                } else {
                    state = locationValue || null;
                }
            }


            const payload = [
                {
                    type: "SET",
                    value: {
                        "oldInfo.jobTitle": form.jobTitle,
                        // "oldInfo.agreementType": Number(form.agreementType),
                        ...(form.agreementType && {
                            "oldInfo.agreementType": Number(form.agreementType),
                        }),
                        "oldInfo.startDate": form.startDate,
                        "oldInfo.expiryDate": form.expiryDate,
                        "oldInfo.oldAddress": form.location
                            ? {
                                country: form.country?.label,
                                city,
                                state
                            }
                            : {}
                    }
                }
            ];

            formData.append("payload", JSON.stringify(payload));

            if (filesChanged) {
                files.forEach(f => formData.append("file", f));
            }

            formData.append("postActions[]", "UpdateAgreement");
            const res = await updateAgreementLeadCompany({
                coll: "LeadCompany",
                uiid: companyUiid,
                data: formData,
            });

            if (res?.data) {
                showToast("Information updated successfully", "success");
                setFilesChanged(false);
                onUpdated?.();
            } else {
                showToast("Failed to update information", "error");
            }
        } catch (err) {
            console.error("failed to update", err);
        } finally {
            setLoading(false);
        }
    };

    const viewAgreement = async (fileKey) => {
        const query = new URLSearchParams({
            key: fileKey,
            coll: "LeadCompany",
            html: true,
        }).toString();

        const url = `${ENDPOINTS.LEAD_COMPANY.AGREEMENT_URL}?${query}`;
        setAwsLoading(true);
        try {
            setAwsUrl("");
            setAwsHtml("");
            const response= await axiosRequest({method:"GET",url})
            setAwsUrl(response?.data?.data?.url || "");
            setAwsHtml(response?.data?.data?.htmlContent || "");
        } catch (err) {
        } finally {
            setAwsLoading(false);
        }
    };

    useEffect(() => {
        if (!oldInfo) return;
        if (Array.isArray(oldInfo.agreement)) {
            setExistingFiles(oldInfo.agreement);
        }
        const countryObj = oldInfo.oldAddress?.country
            ? {
                label: oldInfo.oldAddress.country,
                value: oldInfo.oldAddress.country,
                id: oldInfo.oldAddress.country,
            }
            : "";

        let locationObj = "";
        if (oldInfo.oldAddress?.city && oldInfo.oldAddress?.state) {
            locationObj = {
                label: `${oldInfo.oldAddress.city} - ${oldInfo.oldAddress.state}`,
                value: `${oldInfo.oldAddress.city} - ${oldInfo.oldAddress.state}`,
            };
        } else if (oldInfo.oldAddress?.state) {
            locationObj = {
                label: oldInfo.oldAddress.state,
                value: oldInfo.oldAddress.state,
            };
        }

        setForm({
            jobTitle: oldInfo.jobTitle || "",
            agreementType: oldInfo.agreementType || "",
            startDate: oldInfo.startDate ? new Date(oldInfo.startDate) : "",
            expiryDate: oldInfo.expiryDate ? new Date(oldInfo.expiryDate) : "",
            country: countryObj,
            location: locationObj,
        });
    }, [oldInfo]);


    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <LogoLoader />
            </div>
        );
    }
    return (
        <div className="bg-white rounded-lg p-4 sm:p-6">
            <div className="mb-6">
                <div className="flex max-w-xl flex-col sm:flex-row items-start sm:items-end gap-3 sm:gap-2">
                    <div className="w-full sm:flex-1">
                        <FormFieldSet
                            type="file"
                            placeholder="Upload Files"
                            title="Upload Agreements"
                            // required
                            multiple
                            onChange={handleFileChange}
                        />
                        {existingFiles.length > 0 && (
                            <div className="mt-3 space-y-2">
                                <p className="text-sm font-medium text-gray-700">
                                    Uploaded Agreements
                                </p>

                                {existingFiles.map((file, index) => (
                                    <div
                                        key={file._id || index}
                                        className="flex items-center justify-between rounded border px-3 py-2"
                                    >
                                        <span className="text-sm text-gray-800 truncate">
                                            {file.name}
                                        </span>

                                        <div className="flex gap-3">
                                            {/* <a
                                            href={`${process.env.REACT_APP_S3_BASE_URL}/${file.key}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 text-sm"
                                        >
                                            View
                                        </a> */}
                                            <button
                                                className="text-blue-600 text-sm"
                                                onClick={async () => {
                                                    setViewModal(true);
                                                    await viewAgreement(file.key);
                                                }}
                                            >
                                                View
                                            </button>

                                            {/* <button
                                                className="text-red-600 text-sm"
                                                onClick={() =>
                                                    setExistingFiles(prev =>
                                                        prev.filter((_, i) => i !== index)
                                                    )
                                                }
                                            >
                                                Remove
                                            </button> */}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    {/* <Button
                        title="Upload"
                        size="md"
                        variant="outlined"
                        className="w-full sm:w-auto"
                    /> */}
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-6">
                <FormFieldSet
                    type="text"
                    title="Job Title"
                    placeholder="Enter"
                    shadow={true}
                    value={form.jobTitle}
                    onChange={value => handleChange("jobTitle", value)}
                />
                <FormFieldSet
                    type="countriesUsAndCanada"
                    title="Country"
                    placeholder="Select"
                    shadow={true}
                    options={[]}
                    value={form.country}
                    onChange={val => {
                        handleChange("country", val)
                    }}
                />
                <FormFieldSet
                    type="atscitiesState"
                    title="Location"
                    placeholder="Enter"
                    shadow={true}
                    value={form.location}
                    parentValue={{ country: form.country?.id }}
                    onChange={val => handleChange("location", val)}
                    disabled={!form.country}
                    showSearch
                />
                <FormFieldSet
                    title="Starting Date"
                    placeholder="Enter"
                    type="datepicker"
                    minDate={yesterday}
                    shadow={true}
                    value={form.startDate}
                    onChange={val => handleChange("startDate", val)}
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-6">
                <FormFieldSet
                    title="Expiry Date"
                    placeholder="Select"
                    type="datepicker"
                    minDate={yesterday}
                    shadow={true}
                    options={[]}
                    value={form.expiryDate}
                    onChange={val => handleChange("expiryDate", val)}
                />
                <FormFieldSet
                    type="select"
                    title="Agreement Type"
                    placeholder="Select"
                    shadow={true}
                    options={[
                        { label: "Had a closure", value: 1 },
                        { label: "Agreement Signed", value: 2 },
                    ]}
                    value={form.agreementType}
                    onChange={val => handleChange("agreementType", val)}
                />
            </div>
            <div className="flex justify-end">
                <Button
                    title="Save"
                    size="md"
                    variant="contained"
                    color="primary"
                    className="bg-orange-500 hover:bg-orange-600 text-white px-8"
                    onClick={() => handleSave()}
                />
            </div>
            {viewModal && (
                <Modal
                    isOpen={viewModal}
                    onClose={() => setViewModal(false)}
                    title="Agreement Viewer"
                    width="max-w-6xl"
                >
                    <DocumentViewerATS
                        AwsResumeUrl={awsUrl}
                        urlLoading={awsLoading}
                        htmlFormat={awsHtml}
                    />
                </Modal>
            )}

        </div>
    );
};

export default OldInformation;